import dateHandler from "@/composables/dateUtil";
import React from "react";

interface RejectReasonProps {
  rejectedBy: string | null;
  reason: string;
  updatedAt: string;
}

const DisplayRejectReason: React.FC<RejectReasonProps> = ({
  rejectedBy,
  reason,
  updatedAt,
}) => {
  if (!reason) return null;
  const { formatDate } = dateHandler();
  return (
    <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-full">
      <div className="tw-px-6 tw-py-4">
        <span className="tw-text-[#232323] tw-text-xs tw-font-medium">
          Rejected by
        </span>
        <h2 className="tw-text-[#146C94] tw-text-sm tw-font-semibold tw-mt-1">
          {rejectedBy}
        </h2>
      </div>
      <hr className="tw-border-[#E9EAEB]" />
      <div className="tw-px-6 tw-flex tw-flex-col tw-gap-2 tw-py-4">
        <span className="tw-text-[#232323] tw-text-xs tw-font-medium">
          Reason
        </span>
        <p className="tw-text-[#232323] tw-text-sm tw-font-medium">{reason}</p>
        <span className="tw-text-[#809199] tw-text-xs tw-font-medium">
          {formatDate(updatedAt)}
        </span>
      </div>
    </div>
  );
};

export default DisplayRejectReason;
